import state from './moduleOvertimeState.js'
import mutations from './moduleOvertimeMutations.js'
import actions from './moduleOvertimeActions.js'
import getters from './moduleOvertimeGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}